module.exports = __webpack_public_path__ + "img/img2.9fe1606d.png";